'use client';
import React, { useContext } from 'react';

/**
 * Represents the inner context value for the Calendar component.
 */

/**
 * Props for the MonthDropdown component.
 */

var CalendarContext = /*#__PURE__*/React.createContext({});
export var CalendarProvider = CalendarContext.Provider;
export var useCalendarContext = function useCalendarContext() {
  return useContext(CalendarContext);
};
export default CalendarContext;